import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const TimeIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "time",
  "TimeIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g fill="none"><g clipPath="url(#clip0_377_142)"><path d="M7.58464 6.75756V3.20752H6.41797V7.24081L8.92216 9.745L9.74711 8.92004L7.58464 6.75756Z" fill={colorList[0]} fillOpacity="1"/><path d="M7.0013 0.291016C3.29639 0.291016 0.292969 3.29444 0.292969 6.99935C0.292969 10.7043 3.29639 13.7077 7.0013 13.7077C10.7062 13.7077 13.7096 10.7043 13.7096 6.99935C13.7096 3.29444 10.7062 0.291016 7.0013 0.291016ZM1.45964 6.99935C1.45964 3.93877 3.94072 1.45768 7.0013 1.45768C10.0619 1.45768 12.543 3.93877 12.543 6.99935C12.543 10.0599 10.0619 12.541 7.0013 12.541C3.94072 12.541 1.45964 10.0599 1.45964 6.99935Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="1"/></g><defs><clipPath id="clip0_377_142"><rect width="14" height="14" fill={colorList[1]} fillOpacity="1"/></clipPath></defs></g></svg>
);

export default TimeIcon;
